/**
 * @description Enum define by Innso and used inside Dydu
 * These enums could be pass througth Dydu bot response actionGui key
 */

export default Object.freeze({
  ESCALADE: 'ESCALADE',
  ENDTALK: 'ENDTALK',
  HISTORY: 'HISTORY',
})
